const styles = {
    normalFlex: "flex items-center",
    custom_container: "w-11/12 hidden sm:block",
    heading: 'text-[27px] text-center md:text-start font-[600] font-Roboto pb-[20px]',
    section: 'w-11/12 mx-auto',
    active_indicator: "absolute bottom-[-27%] left-0 h-[3px] w-full bg-[crimson]",
    button: 'w-[150px] bg-black h-[50px] my-3 flex items-center justify-center rounded-xl cursor-pointer',
    input: "w-full border p-1 rounded-[5px]",
};

export default styles;
